exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".image--3quoW{width:100%}", ""]);

// Exports
exports.locals = {
	"image": "image--3quoW"
};